import angular from "angular";
import component from "./access-control-crud.component";

angular.module('accessControlCrud', [component]);

export default 'accessControlCrud';



// WEBPACK FOOTER //
// ./resources/assets/modules/access-control-crud/access-control-crud.module.js